









































































































































import { Component, Vue, Watch } from "vue-property-decorator";

import BaseVue from "@/core/BaseVue";
import GenericEdit from "@/core/Generics/GenericEdit";
import MemberType from "@/models/porposal/memberType.Model";
@Component
export default class MemberTypeEdit extends GenericEdit<MemberType> {
  constructor() {
    super();
    this.controller = "MemberTypes";
    this.model = new MemberType();
  }
    @Watch("model.isTheResponsableMember")
  onIsResponsableMemberChange(){
      if(this.model.isTheResponsableMember)
        this.model.isUniqueInPorposal =  true;
        else{
            this.model.isUniqueInPorposal = false;
        }

  }
}
